var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIc20HeartFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17L3.4776 10.9652C2.5248 10.0839 2 8.91026 2 7.66036C2 6.41045 2.5248 5.23678 3.4776 4.35477C5.2536 2.71131 8.0416 2.56353 10 3.9091C11.9584 2.56353 14.7464 2.71131 16.5224 4.35477C17.4752 5.23678 18 6.41045 18 7.66036C18 8.91026 17.4752 10.0839 16.5224 10.9652L10 17Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc20HeartFull);
export default __webpack_public_path__ + "static/media/ic20-heart-full.d611f543bd49ed300dc5f27702cb3fe3.svg";
export { ForwardRef as ReactComponent };